module.exports = __webpack_public_path__ + "./img/ArticuloEditar.0b35269a7c5340e6bc47d73a2aebdf9a.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/ArticuloEditar.png
// module id = ./public/img/Help/ArticuloEditar.png
// module chunks = 0